import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';

const getFileIcon = (contentType) => {
  if (!contentType) return 'attachment';

  switch (contentType) {
    case 'application/pdf':
      return 'file-pdf';
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'file-excel';
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'file-word';
    case 'text/calendar':
    case 'application/ics':
      return 'calendar';
    default:
      if (contentType.startsWith('image/')) {
        return 'file-image';
      }
      return 'file-alt';
  }
};

const AttachmentIndicator = ({ attachment = {} }) => {
  if (!attachment || Object.keys(attachment).length === 0) {
    return null;
  }

  const displayName = attachment.filename || attachment.contentType || 'Attachment';
  const iconName = getFileIcon(attachment.contentType || attachment.content_type);

  return (
    <div className="outreach-card-tab-group--item">
      <Icon
        icon={iconName}
        iconKit="gt2"
        size={1}
        className="outreach-card-tab-group--item"
        aria-label={`Download attachment: ${displayName}`}
      />
      <span className="outreach-card-tab-group--item-text">{displayName}</span>
    </div>
  );
};

AttachmentIndicator.propTypes = {
  attachment: PropTypes.shape({
    content_disposition: PropTypes.string,
    content_type: PropTypes.string,
    contentType: PropTypes.string,
    filename: PropTypes.string,
    content_id: PropTypes.string,
    size: PropTypes.number,
  }),
};

export default AttachmentIndicator;
